import React, { useState, useEffect, Fragment, useRef } from "react";
import { Col, Card, CardHeader, CardBody, Form, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import { H3, Btn, Breadcrumbs } from "../../../AbstractElements";
import { getPaymentList, showPaymentMethod } from "../../../CommonURL";
import { getDataWithToken } from "../../../Utils/restUtils";
import { PaymentColumns } from "../../../Data/MockTable/TempData";
import Transparentspinner from "../../Common/loader/Transparentspinner";
import Progress from "../../Common/Progress";
import { EarningsSvg } from "../../../Data/Widgets/General/Data";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useLocation, useNavigate } from "react-router";
import { Filter, PaymentMethod, Search, Status } from "../../../Constant";
import { useForm } from "react-hook-form";
import { paymentStatusOptions } from "../../../Constant/DropdownValue";
import CompanyFilter from "../../Common/Filters/CompanyFilter";
import IndustryFilter from "../../Common/Filters/IndustryFilter";

const PaymentTable = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isStatus = useRef(null);
  const isPayStatus = useRef(null);
  const searchParams = location.search;
  const params = new URLSearchParams(searchParams);
  const sortedBy = params.get("sortBy") || "";
  const sortedOrder = params.get("sortOrder") || "";
  const [filters, setFilters] = useState({
    search: params.get("search") || "",
    status: params.get("status") || "",
    payStatus: params.get("payStatus") || "",
    start_date: params.get("start_date")
      ? moment(params.get("start_date"), "DD-MM-YYYY").toDate()
      : "",
    end_date: params.get("end_date")
      ? moment(params.get("end_date"), "DD-MM-YYYY").toDate()
      : "",
    industry_type_id: params.get("industry_type_id") || "",
    company_id: params.get("company_id") || "",
  });
  const [dateRange, setDateRange] = useState([filters.start_date, filters.end_date]);
  const [startDate, endDate] = dateRange;
  const [tempList, setTempList] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [isCompany, setIsCompany] = useState("");
  const [isIndustry, setIsIndustry] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [StaticWidgetsData, setStaticWidgetsData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    column: sortedBy,
    order: sortedOrder,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const formatStartDate = startDate
  ? moment(startDate).format("DD-MM-YYYY")
  : "";

const formatEndDate = endDate
  ? moment(endDate).format("DD-MM-YYYY")
  : "";

  const { register, setValue, handleSubmit } = useForm({
    defaultValues: {
      search: filters.search,
      payStatus: filters.payStatus,
      status: filters.status,
    },
  });

  const statusOptions = [
    { value: "online", label: "Online" },
    { value: "offline", label: "Offline" },
  ];

  useEffect(() => {
    fetchPayment(1);
  }, []);
  useEffect(() => {
    fetchPaymentMethods();
  }, []);


  const fetchPaymentMethods = async () => {
    setLoading(true);
    const res = await getDataWithToken(showPaymentMethod);

    if (res?.status === true) {
      setPaymentMethods(res.data);
    } else {
      toast.error("Failed to load payment methods");
    }

    setLoading(false);
  };
  useEffect(() => {
    setValue("search", filters.search);
    setValue("payStatus", filters.payStatus);
    setValue("status", filters.status);
  }, [setValue, filters]);

  const fetchPayment = async (page, size = perPage) => {
    setLoading(true);
    const response = await getDataWithToken(
      getPaymentList +
        `?page=${page}&page_length=${size}&search=${filters.search}
            &start_date=${formatStartDate}&end_date=${formatEndDate}&status=${filters.status}&payment_method=${filters.payStatus}
            &sort_by=${sortConfig.column ? sortConfig.column : ""}&sort_order=${sortConfig.order ? sortConfig.order : ""} &industry_type_id=${filters.industry_type_id}
     &company_id=${filters.company_id}`,
    );
    setResetPaginationToggle(!resetPaginationToggle);
    let serialNo = (page - 1) * size + 1;
    setTempList(
      response.data.payment.data.map((e, index) => {
        return {
          Si: serialNo + index,
          user_id: e.user_id,
          order_id: e.order_id,
          Name: <span>{e.user_name}</span>,
          Invoice_no: e.invoice_number,
          Txn_id: e.transaction_id,
          Industry: e.industry_name,
          Company_name: e.company_name,
          Company_id: e.company_id,
          Payment_method: e.payment_method_name,
          Date: e.payment_date,
          Amount: e.paid_amount,
          client_url:e.client_url,
          Status: e.payment_status,
          industryTypeId:e.industry_type_id
        };
      }),
    );
    setStaticWidgetsData([
      {
        id: 1,
        title: "Total",
        counter: parseFloat(response.data.total.replace(/,/g, "")),
        svg: <EarningsSvg />,
        class: "progress-gradient-secondary",
        progress: "75%",
      },
    ]);
    setTotalRows(response.data.payment.total);
    setLoading(false);
  };

  const onSubmit = async (data) => {
    const search = data.search || "";
    const start_date = startDate ? moment(startDate).format("DD-MM-YYYY") : "";
    const end_date = endDate ? moment(endDate).format("DD-MM-YYYY") : "";
    const status = data.status || "";
    const payStatus = data.payStatus || "";
    const industry_type_id = isIndustry?.value || "";
    const company_id = isCompany?.value || "";

    const queryParams = new URLSearchParams({
      search,
      start_date,
      end_date,
      status,
      payStatus,
      industry_type_id,
      company_id,
      sortBy: sortConfig.column || "",
      sortOrder: sortConfig.order || "",
    }).toString();

    navigate(`/billing/payment-list?${queryParams}`);

    setFilters({
      search,
      start_date,
      end_date,
      status,
      payStatus,
      industry_type_id,
      company_id,
    });

  };
  const ResetFileter = () => {
    setIsCompany(null);
    setIsIndustry(null);
    setDateRange([null, null]);
    setSortConfig({ column: "", order: "" });
    setCurrentPage(1);

    setFilters({
      search: "",
      start_date: "",
      end_date: "",
      status: "",
      companyId: "",
      industryId: "",
    });

    navigate("/billing/payment-list");
  };
  const handleChange = (date) => {
    setstartDate(date);
  };

  const handlePageChange = (page) => {
    fetchPayment(page);
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    fetchPayment(page, newPerPage);
    setPerPage(newPerPage);
  };

  return (
    <Fragment>
      {loading && <Transparentspinner />}
      <Breadcrumbs mainTitle="Payment" parent="Companies" title="Payment" />
      <Progress details={StaticWidgetsData} />
      <Card>
        <CardHeader>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <H3>Payment List</H3>
          </div>
        </CardHeader>
        <CardBody>
          <Form
            className="needs-validation"
            noValidate
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row className="ps-3 gap-sm-3 gap-md-2 mb-4 filterGap">
              <Col sm="12" md="5" lg="2">
                <input
                  name="search"
                  className="form-control"
                  placeholder={Search}
                  id="validationCustom01"
                  type="text"
                  {...register("search")}
                />
              </Col>
              <Col sm="12" md="5" lg="3" className="form-element">
                <div style={{ position: "relative", zIndex: 2 }}>
                  <DatePicker
                    className="form-control digits w-100"
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => {
                      setDateRange(update);
                    }}
                    isClearable={!!(startDate || endDate)}
                    monthsShown={2}
                    popperPlacement="bottom"
                    calendarClassName="parallel-calendar"
                    placeholderText="Select Date Range"
                    dateFormat="dd-MM-yyyy" 
                  />
                </div>
              </Col>
                <Col sm="12" md="5" lg="3" className="form-element">
                <IndustryFilter
                  IsIndustry={isIndustry}
                  setIsIndustry={setIsIndustry}
                  selectedIndustry={filters.industry_type_id}
                />
              </Col>
              <Col sm="12" md="5" lg="3" className="form-element">
                <CompanyFilter
                  IsCompany={isCompany}
                  setIsCompany={setIsCompany}
                  industryId={isIndustry?.value}
                  selectedCompany={filters.company_id}
                />
              </Col>
              <Col sm="12" md="5" lg="2" className="form-element">
                <select
                  className="form-select"
                  ref={isStatus}
                  {...register("status")}
                >
                  <option value="">{Status}</option>
                  {paymentStatusOptions.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </Col>
              <Col sm="12" md="5" lg="2" className="form-element">
                <select
                  className="form-control"
                  value={filters.payStatus}
                  onChange={(e) => {
                    setFilters((prev) => ({
                      ...prev,
                      payStatus: e.target.value,
                    }));
                    setValue("payStatus", e.target.value);
                  }}
                >
                  <option value="">Select Method</option>
                  {paymentMethods?.map((item, index) => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </Col>
              <Col sm="12" md="5" lg="1" className="custom-filtrs">
                <Btn attrBtn={{ color: "primary" }} type="submit">
                  {Filter}
                </Btn>
              </Col>
               <Col sm="12" md="5" lg="1" className="">
                 <button
                    type="button"
                    className="btn btn-primary mb-2 ms-2"
                    onClick={ResetFileter}
                    >
                    Reset
                  </button>
              </Col>
            </Row>
          </Form>
          <div className="order-history table-responsive">
            <DataTable
              columns={PaymentColumns}
              data={tempList}
              pagination
              paginationServer
              defaultSortAsc
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default PaymentTable;
